import React from 'react';
import { RootState, useAppSelector } from '@/reduxStore/rootReducer';
import { checkIfUserHasAtLeastOneAllowedPermission } from '@/helpers/checkIfUserHasAtLeastOneAllowedPermission';
import { checkIfUserHasAllNecessaryPermissions } from '@/helpers/checkIfUserHasAllNecessaryPermissions';
import { clientViewService } from '@/helpers/clientViewService';
import { UserPermission } from '@/api/client';

interface PermissionCheckerProps {
    children: any;
    allowedPermissions?: UserPermission[];
    necessaryPermissions?: UserPermission[];
    VACRequiredPermissions?: UserPermission[];
}

const PermissionChecker: React.FC<PermissionCheckerProps> = ({
    children,
    allowedPermissions,
    necessaryPermissions,
    VACRequiredPermissions,
}) => {
    const userPermissions = useAppSelector((state: RootState) => state.roles.userPermissions);
    const isViewAsClient = clientViewService.isViewAsClient();

    if (!userPermissions || userPermissions.length < 1) return null;
    if (isViewAsClient) {
        if (VACRequiredPermissions) {
            if (VACRequiredPermissions.length == 0) {
                return <>{children}</>;
            }
            const isHasNecessaryPermissions = checkIfUserHasAllNecessaryPermissions(
                VACRequiredPermissions,
                userPermissions,
            );
            if (!isHasNecessaryPermissions) {
                return null;
            } else {
                return <>{children}</>;
            }
        }
        return null;
    } else {
        const isHasAllowedPermission = checkIfUserHasAtLeastOneAllowedPermission(
            allowedPermissions,
            userPermissions,
        );
        const isHasNecessaryPermissions = checkIfUserHasAllNecessaryPermissions(
            necessaryPermissions,
            userPermissions,
        );

        if (!isHasNecessaryPermissions) return null;

        if (!isHasAllowedPermission) return null;

        return <>{children}</>;
    }
};

export default PermissionChecker;
